<template>
  <div id="adjustment-history">
    <div class="row mt-4 mb-4 pl-3">
      <div class="col-md-3 col col-sm-6">
        <total-amount-view
          :amount="data.amount | price"
          icon="fa fa-usd-circle"
          :icon-color="'color-yellow-star'"
          title="Reembolso Solicitado:"
        />
      </div>
      <div class="col-md-3 col col-sm-6 mt-3 mt-md-0 mt-sm-3">
        <total-amount-view
          :amount="data.adjustmentsTotal | price"
          icon="fa fa-usd-circle"
          icon-color="color-primary-8"
          title="Ajuste Realizado:"
        />
      </div>
      <div class="col-md-3 col col-sm-6 mt-md-0 mt-sm-3 mt-3 mt-md-0 mt-sm-3">
        <total-amount-view
          :amount="data.amountToRefund | price"
          icon="fa fa-usd-circle"
          icon-color="color-green"
          title="Total a Reembolsar:"
        />
      </div>
    </div>
    <section-title :has-line="true" title="Ajustes Realizados" />
    <custom-result-not-found
      v-if="adjustmentHistory.length === 0"
      text="No cuenta con ajustes en sistema."
    />
    <div v-for="row of adjustmentHistory" :key="row.id">
      <result-row-adjustment
        :data="row"
        :status-id="data.statusId"
        @on-delete="$emit('on-delete-adjustment', $event)"
        @on-edit="$emit('on-edit-adjustment', $event)"
      />
    </div>
    <pagination
      v-if="showPagination"
      :data="pagination"
      show-text
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import { getAdjustmentHistory as _getAdjustmentHistory } from '@/modules/reinbursement/api.js';
import Pagination from 'pagination';
import ResultRowAdjustment from './ResultRowAdjustment.vue';
import TotalAmountView from './TotalAmountView.vue';
import SectionTitle from 'SectionTitle';

const DEFAULT_PAGE_SIZE = 10;

export default {
  name: 'AdjustmentHistory',
  components: {
    SectionTitle,
    CustomResultNotFound,
    Pagination,
    ResultRowAdjustment,
    TotalAmountView,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      adjustmentHistory: [],
      pagination: {
        currentPage: 1,
        totalItemCount: 1,
        pageCount: 1,
        count: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    };
  },
  computed: {
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.pageSize;
    },
  },
  async mounted() {
    await this.getHistory(1);
  },
  methods: {
    async getHistory(page) {
      this.adjustmentHistory = [];
      const searchParams = {
        requestId: this.data.requestId,
        pageIndex: page,
        pageSize: this.pagination.pageSize,
      };

      try {
        const { data: res } = await _getAdjustmentHistory(searchParams);
        this.adjustmentHistory = [...res.data];
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.totalItemCount,
          pageCount: res.pageCount,
          currentPage: res.currentPage,
          count: res.count,
        };
      } catch (err) {
        if (err.response != null)
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error',
            5000
          );
      }
    },
    async goToPageHandler(page) {
      this.pagination.currentPage = page;
      await this.getHistory(page);
    },
  },
};
</script>
